export function parseJsonArray<T = unknown>(value: unknown): T[] | undefined {
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : undefined;
    } catch {
      return undefined;
    }
  }

  if (Array.isArray(value)) {
    return value;
  }

  return undefined;
}

export function toNumber(value: unknown): number | undefined {
  if (typeof value === "number") {
    return value;
  }

  if (typeof value === "string") {
    if (value.trim() === "") {
      return undefined;
    }
    const parsed = Number(value);
    return isNaN(parsed) ? undefined : parsed;
  }

  return undefined;
}

export function toNumberArray(value: unknown): number[] | undefined {
  const array = parseJsonArray<unknown>(value);
  if (!array) return undefined;

  const numbers = array
    .map(toNumber)
    .filter((n): n is number => n !== undefined);
  return numbers.length === array.length ? numbers : undefined;
}

export function toStringArray(value: unknown): string[] | undefined {
  const array = parseJsonArray<unknown>(value);
  if (!array) return undefined;

  const strings = array.map(String);
  return strings;
}
